import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { ToastType } from "@/enums";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";

export const useDeleteOrganizationRole = () => {
  const queryClient = useQueryClient();
  const userToken = useUserToken();

  return useMutation(
    ({ organizationId, roleId }: { organizationId: number; roleId: number }) =>
      fetch(ENDPOINTS.delete_organization_role(organizationId, roleId), {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
      }),
    {
      onSuccess: async response => {
        if (response.ok) {
          queryClient.invalidateQueries(["organization-roles"]);
          displayToast("Role deleted successfully", ToastType.success);
        } else {
          const data = await response.json();
          displayErrorToast(data.message || "Failed to delete role");
        }
      },
      onError: () => {
        displayErrorToast("Failed to delete role");
      },
    },
  );
};
